import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Box, Container } from '@material-ui/core'
import { useSectionMetaData } from '@v4/components/common/SectionItem'
import clsx from 'clsx'
import { CTA_VARIANTS } from '../Sections.const'

const CallToAction = ({ variant, Element }) => {
	const metaData = useSectionMetaData()

	return (
		<Box className={clsx(variant, 'section-cta')}>
			<Container className="section-cta-content">{Element && <Element metaData={metaData} />}</Container>
		</Box>
	)
}

CallToAction.propTypes = {
	variant: PropTypes.oneOf(Object.values(CTA_VARIANTS)),
	Element: PropTypes.elementType,
}

CallToAction.defaultProps = {
	variant: CTA_VARIANTS.VARIANT_1,
}

export default memo(CallToAction)
